 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTMLEBB from '@/components/xhtml/ebb'
 import XHTMLMM from '@/components/xhtml/mm'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML01_TITLE from '@/components/xhtml/01_Title'
 import XHTML03_CHAPTERONE from '@/components/xhtml/03_Chapterone'
 import XHTML04_CHAPTERTWO from '@/components/xhtml/04_Chaptertwo'
 import XHTML05_CHAPTERTHREE from '@/components/xhtml/05_Chapterthree'
 import XHTML06_CHAPTERFOUR from '@/components/xhtml/06_Chapterfour'
 import XHTML07_CHAPTERFIVE from '@/components/xhtml/07_Chapterfive'
 import XHTML08_CHAPTERSIX from '@/components/xhtml/08_Chaptersix'
 import XHTML09_CHAPTERSEVEN from '@/components/xhtml/09_Chapterseven'
 import XHTML10_CHAPTEREIGHT from '@/components/xhtml/10_Chaptereight'
 import XHTML11_CHAPTERNINE from '@/components/xhtml/11_Chapternine'
 import XHTML12_CHAPTERTEN from '@/components/xhtml/12_Chapterten'
 import XHTML13_CHAPTERELEVEN from '@/components/xhtml/13_Chaptereleven'
 import XHTML14_CHAPTERTWELVE from '@/components/xhtml/14_Chaptertwelve'
 import XHTML15_CHAPTERTHIRTEEN from '@/components/xhtml/15_Chapterthirteen'
 import XHTML16_CHAPTERFOURTEEN from '@/components/xhtml/16_Chapterfourteen'
 import XHTML17_CHAPTERFIFTEEN from '@/components/xhtml/17_Chapterfifteen'
 import XHTML18_CHAPTERSIXTEEN from '@/components/xhtml/18_Chaptersixteen'
 import XHTML19_CHAPTERSEVENTEEN from '@/components/xhtml/19_Chapterseventeen'
 import XHTML20_CHAPTEREIGHTEEN from '@/components/xhtml/20_Chaptereighteen'
 import XHTML21_CHAPTERNINETEEN from '@/components/xhtml/21_Chapternineteen'
 import XHTML22_CHAPTERTWENTY from '@/components/xhtml/22_Chaptertwenty'
 import XHTML23_CHAPTERTWENTYONE from '@/components/xhtml/23_Chaptertwentyone'
 import XHTML24_CHAPTERTWENTYTWO from '@/components/xhtml/24_Chaptertwentytwo'
 import XHTML25_CHAPTERTWENTYTHREE from '@/components/xhtml/25_Chaptertwentythree'
 import XHTML26_CHAPTERTWENTYFOUR from '@/components/xhtml/26_Chaptertwentyfour'
 import XHTML27_CHAPTERTWENTYFIVE from '@/components/xhtml/27_Chaptertwentyfive'
 import XHTML28_CHAPTERTWENTYSIX from '@/components/xhtml/28_Chaptertwentysix'
 import XHTML29_CHAPTERTWENTYSEVEN from '@/components/xhtml/29_Chaptertwentyseven'
 import XHTML30_CHAPTERTWENTYEIGHT from '@/components/xhtml/30_Chaptertwentyeight'
 import XHTML31_CHAPTERTWENTYNINE from '@/components/xhtml/31_Chaptertwentynine'
 import XHTML32_CHAPTERTHIRTY from '@/components/xhtml/32_Chapterthirty'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
 import XHTMLORIMAD from '@/components/xhtml/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/00_Cover",
 			"name" : "xhtml/00_Cover",
 			"component" : XHTML00_COVER
 		},
 		{
 			"path" : "/xhtml/ebb",
 			"name" : "xhtml/ebb",
 			"component" : XHTMLEBB
 		},
 		{
 			"path" : "/xhtml/mm",
 			"name" : "xhtml/mm",
 			"component" : XHTMLMM
 		},
 		{
 			"path" : "/xhtml/love_1",
 			"name" : "xhtml/love_1",
 			"component" : XHTMLLOVE_1
 		},
 		{
 			"path" : "/xhtml/01_Title",
 			"name" : "xhtml/01_Title",
 			"component" : XHTML01_TITLE
 		},
 		{
 			"path" : "/xhtml/03_Chapterone",
 			"name" : "xhtml/03_Chapterone",
 			"component" : XHTML03_CHAPTERONE
 		},
 		{
 			"path" : "/xhtml/04_Chaptertwo",
 			"name" : "xhtml/04_Chaptertwo",
 			"component" : XHTML04_CHAPTERTWO
 		},
 		{
 			"path" : "/xhtml/05_Chapterthree",
 			"name" : "xhtml/05_Chapterthree",
 			"component" : XHTML05_CHAPTERTHREE
 		},
 		{
 			"path" : "/xhtml/06_Chapterfour",
 			"name" : "xhtml/06_Chapterfour",
 			"component" : XHTML06_CHAPTERFOUR
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js